/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type PublicationWarning = typeof PublicationWarning[keyof typeof PublicationWarning];


export const PublicationWarning = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_4: 4,
} as const;
